import { useState } from 'react'
import {
  CButton,
  CContainer,
  CHeader,
  CHeaderNav,
  CNavItem,
  CSidebar,
  CSidebarBrand,
  CSidebarHeader,
  CSidebarNav,
  CSidebarToggler,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {
  cilApplicationsSettings,
  cilBook,
  cilCalendarCheck,
  cilChartLine,
  cilExitToApp,
  cilMenu,
  cilPeople,
  cilSettings,
  cilSpeedometer,
  cilWarning,
} from '@coreui/icons'
import { NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import mark from '../assets/larice-mark.png'

const navItems = [
  { to: '/console', label: 'Dashboard', icon: cilSpeedometer, role: 'viewer' },
  { to: '/console/drafts', label: 'Audit drafts', icon: cilBook, role: 'member' },
  { to: '/console/workloads', label: 'Workloads', icon: cilChartLine, role: 'member' },
  { to: '/console/operations', label: 'Operations', icon: cilWarning, role: 'operator' },
  { to: '/console/services', label: 'Service launchpad', icon: cilApplicationsSettings, role: 'member' },
  { to: '/console/catalog', label: 'Catalogue', icon: cilSettings, role: 'admin' },
] as const

export function ConsoleLayout() {
  const [visible, setVisible] = useState(true)
  const { user, logout, hasRole } = useAuth()

  return (
    <div className="console-shell">
      <CSidebar
        className="console-sidebar"
        position="fixed"
        visible={visible}
        onVisibleChange={setVisible}
      >
        <CSidebarHeader>
          <CSidebarBrand href="/">
            <img src={mark} alt="" />
            <span>
              <strong>LARICE</strong>
              <small>H100 Console</small>
            </span>
          </CSidebarBrand>
        </CSidebarHeader>
        <CSidebarNav>
          {navItems
            .filter((item) => hasRole(item.role))
            .map((item) => (
              <CNavItem key={item.to}>
                <NavLink to={item.to} end={item.to === '/console'} className="nav-link">
                  <CIcon customClassName="nav-icon" icon={item.icon} />
                  {item.label}
                </NavLink>
              </CNavItem>
            ))}
          <CNavItem className="mt-auto">
            <a className="nav-link" href="/observatory">
              <CIcon customClassName="nav-icon" icon={cilCalendarCheck} />
              Public Observatory
            </a>
          </CNavItem>
        </CSidebarNav>
        <CSidebarHeader className="console-sidebar__user">
          <CIcon icon={cilPeople} />
          <span>
            <strong>{user?.displayName}</strong>
            <small>{user?.role}</small>
          </span>
        </CSidebarHeader>
        <CSidebarToggler onClick={() => setVisible((value) => !value)} />
      </CSidebar>

      <div className={`console-wrapper ${visible ? 'console-wrapper--sidebar' : ''}`}>
        <CHeader className="console-header" position="sticky">
          <CContainer fluid>
            <CButton
              color="light"
              aria-label="Toggle sidebar"
              onClick={() => setVisible((value) => !value)}
            >
              <CIcon icon={cilMenu} />
            </CButton>
            <div className="console-header__identity">
              <strong>Operations & audit console</strong>
              <span>FreeIPA session · {user?.uid}</span>
            </div>
            <CHeaderNav className="ms-auto">
              <CButton color="light" onClick={() => void logout()}>
                <CIcon icon={cilExitToApp} /> Sign out
              </CButton>
            </CHeaderNav>
          </CContainer>
        </CHeader>
        <main className="console-main">
          <CContainer fluid className="py-4 px-3 px-lg-4">
            <Outlet />
          </CContainer>
        </main>
      </div>
    </div>
  )
}
